import './ErrorIcon.scss';

export function ErrorIcon() {
  return <div className={`error-icon-container`}>X</div>;
}
